import { formatDate, useDictionary } from 'lib/utils';
import { BlogProps } from 'models/blog-types';
import classNames from 'classnames/bind';
import styles from './Blog.module.scss';

const BlogPublishedOn: React.FC<BlogProps> = (props) => {
  const cx = classNames.bind(styles);
  const publishedLabel = useDictionary('Published');
  const { className, blogDetails, language } = props;
  const dateFieldValue = blogDetails?.publishedOn?.value?.toString() || '';
  const emptyDate = '0001-01-01T00:00:00Z';

  if (!dateFieldValue || dateFieldValue === emptyDate) {
    return null;
  }

  return (
    <div className={cx(className)}>
      {publishedLabel}&nbsp;{formatDate(language, dateFieldValue)}
    </div>
  );
};

export default BlogPublishedOn;
